module.exports = __webpack_public_path__ + "img/interativ-title-01.bc3dae3f.png";